import script from "./TopologyStatsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopologyStatsView.vue?vue&type=script&setup=true&lang=ts"

import "./TopologyStatsView.vue?vue&type=style&index=0&id=15f2157c&lang=css"

const __exports__ = script;

export default __exports__